// extracted by mini-css-extract-plugin
module.exports = {"textInputField":"TextInput_textInputField__h-bxa","labelContainer":"TextInput_labelContainer__3pRcT","labelText":"TextInput_labelText__woNuz"};